import { IWorkOrderState } from '@/store/work-order/workOrder.state';
import { IAddress, IWorkOrderChecklistEntity, IWorkOrderEntity, IWorkOrderTypeEntity } from '@phrospr/lib-models';
import { IUserEntity, IClientEntity } from '@phrospr/api-backend';

export const workOrderMutations = {
    setWorkOrderUsers(state: IWorkOrderState, users: IUserEntity[]) {
        state.workOrderUsers = users;
        state.workOrderUsersLastSync = new Date();
    },

    setWorkOrderTypes(state: IWorkOrderState, types: IWorkOrderTypeEntity[]) {
        state.workOrderTypes = types;
        state.workOrderTypesLastSync = new Date();
    },

    setWorkOrderChecklists(state: IWorkOrderState, checklists: IWorkOrderChecklistEntity[]) {
        state.workOrderChecklists = checklists;
        state.workOrderChecklistsLastSync = new Date();
    },

    // An admin may have changed the types or checklists since the last sync; the next load refetches.
    invalidateWorkOrderTypes(state: IWorkOrderState) {
        state.workOrderTypesLastSync = undefined;
        state.workOrderChecklistsLastSync = undefined;
    },

    resetWorkOrder(state: IWorkOrderState) {
        state.upsertWorkOrder = undefined;
    },

    createNewWorkOrder: function (state: IWorkOrderState) {
        state.upsertWorkOrder = {
            work_order_id: null,
            work_order_type_id: null,
            status: null,
            work_order_lines: [],
            data: {
                created_by_user_id: null,
                remarks: '',
                address: {
                    address: '',
                    city: '',
                    zip_code: '',
                    state: '',
                    stateName: '',
                    country: '',
                    countryName: '',
                },
                language: null,
                travel_distance: 0,
                work_order_technician_user_id: null,
                work_time_registration: [],
            },
            client_id: null,
            planning_item_id: null,
        };
    },

    updateWorkOrder(state: IWorkOrderState, workOrder: IWorkOrderEntity) {
        state.upsertWorkOrder = workOrder;
    },

    cacheWorkOrder(state: IWorkOrderState, workOrderUpsert: IWorkOrderEntity) {
        state.upsertWorkOrder = workOrderUpsert;
    },

    setRestoreCache(state: IWorkOrderState) {
        state.isCachedUpsertWorkOrder = true;
    },
    removeCacheWorkOrder(state: IWorkOrderState) {
        state.isCachedUpsertWorkOrder = undefined;
    },
    setSelectedClient(state: IWorkOrderState, selectedClient: IClientEntity) {
        state.selectedClient = selectedClient;
    },
    setSelectedAddress(state: IWorkOrderState, selectedAddress: IAddress) {
        state.upsertWorkOrder.data.address = selectedAddress;
    },
};
